// // components/UpcomingEvents.jsx
// import React, { useRef, useState } from "react";
// import { ChevronRight, Play, X } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useUpcomingEvents } from "../../hooks/useUpcomingEvents";

// /* ─── Subscription helper ────────────────────────────────────────────────── */
// const hasActiveSubscription = () => {
//   try {
//     const raw = localStorage.getItem("userSubscription");
//     if (!raw) return false;
//     const sub = JSON.parse(raw);
//     if (sub?.status !== "Active") return false;
//     if (!sub?.expiryDate) return false;
//     return new Date(sub.expiryDate) > new Date();
//   } catch {
//     return false;
//   }
// };

// /* ─── Pulse Icon ─────────────────────────────────────────────────────────── */
// const PulseIcon = () => (
//   <span className="flex items-center gap-0.5">
//     <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
//     <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse [animation-delay:100ms]" />
//     <span className="w-1 h-1 rounded-full bg-red-500 animate-pulse [animation-delay:200ms]" />
//   </span>
// );

// /* ─── Skeleton Card ──────────────────────────────────────────────────────── */
// const SkeletonCard = () => (
//   <div className="relative min-w-[260px] flex-shrink-0 rounded-2xl overflow-hidden aspect-[3/2] bg-gray-200 animate-pulse" />
// );

// /* ─── Session Info Modal ─────────────────────────────────────────────────── */
// const SessionModal = ({ event, onClose, onJoin, onSubscribe }) => {
//   if (!event) return null;

//   const isSubscribed = hasActiveSubscription();

//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-6"
//       onClick={onClose}
//     >
//       <div
//         className="w-full max-w-sm bg-white rounded-3xl border border-gray-100 shadow-2xl px-6 py-8 flex flex-col items-center gap-5"
//         onClick={(e) => e.stopPropagation()}
//       >
//         {/* Close button */}
//         <div className="w-full flex justify-end -mt-2">
//           <button
//             onClick={onClose}
//             className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
//           >
//             <X className="w-4 h-4 text-gray-500" />
//           </button>
//         </div>

//         {/* Title + status */}
//         <div className="flex flex-col items-center gap-2 -mt-2">
//           <h3 className="text-gray-900 text-xl font-bold tracking-wide">
//             Session Info
//           </h3>
//           <p className="text-green-600 text-base font-semibold flex items-center gap-2">
//             <PulseIcon />
//             Session Started!
//           </p>
//         </div>

//         {/* Event title */}
//         {event.title && (
//           <p className="text-gray-500 text-sm text-center leading-relaxed px-2">
//             {event.title}
//           </p>
//         )}

//         {/* Divider */}
//         <div className="w-full border-t border-gray-100" />

//         {/* CTA */}
//         {isSubscribed ? (
//           <button
//             onClick={() => onJoin(event)}
//             className="w-full flex items-center justify-between bg-green-600 hover:bg-green-700 active:scale-95 rounded-2xl px-5 py-4 transition-all duration-150 shadow-md"
//           >
//             <PulseIcon />
//             <span className="text-white text-base font-bold tracking-wide flex-1 text-center">
//               Join Session
//             </span>
//             <div className="w-7 h-7 bg-white rounded-full flex items-center justify-center">
//               <Play className="w-3.5 h-3.5 text-green-600 ml-0.5" fill="currentColor" />
//             </div>
//           </button>
//         ) : (
//           <button
//             onClick={onSubscribe}
//             className="w-full bg-green-600 hover:bg-green-700 active:scale-95 rounded-2xl px-5 py-4 transition-all duration-150 shadow-md"
//           >
//             <span className="text-white text-base font-bold tracking-wide">
//               Subscribe to Watch
//             </span>
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// /* ─── Helper function to get proper thumbnail URL ───────────────────────── */
// const getThumbnailUrl = (event) => {
//   // Priority 1: Use img field if available
//   if (event.img) return event.img;
  
//   // Priority 2: Use thumbnail field
//   if (event.thumbnail) return event.thumbnail;
  
//   // Priority 3: Extract from YouTube link if present
//   if (event.link) {
//     const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?#]+)/;
//     const match = event.link.match(youtubeRegex);
//     if (match && match[1]) {
//       return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
//     }
//   }
  
//   // Priority 4: Fallback to placeholder
//   return null;
// };

// /* ─── Event Card ─────────────────────────────────────────────────────────── */
// const EventCard = ({ event, onPress }) => {
//   const [imgError, setImgError] = useState(false);
//   const thumbnailUrl = getThumbnailUrl(event);

//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = date.toLocaleString("en-US", { month: "short" });
//     const year = String(date.getFullYear()).slice(2);
//     return `${day}-${month}-${year}`;
//   };

//   const formatTime = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toLocaleTimeString("en-US", {
//       hour: "2-digit",
//       minute: "2-digit",
//       hour12: true,
//     });
//   };

//   const dateSource =
//     event.sheduled_at || event.scheduled_at || event.date || event.createdAt;

//   return (
//     <div
//       className="relative min-w-[260px] flex-shrink-0 snap-start rounded-2xl overflow-hidden cursor-pointer group aspect-[3/2] border border-gray-100 shadow-md hover:shadow-lg transition-shadow"
//       onClick={() => onPress(event)}
//     >
//       {/* Background image with proper thumbnail */}
//       {thumbnailUrl && !imgError ? (
//         <img
//           src={thumbnailUrl}
//           alt={event.title}
//           className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//           onError={() => setImgError(true)}
//           loading="lazy"
//         />
//       ) : (
//         <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-gray-100" />
//       )}

//       {/* Scrim overlay */}
//       <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/65" />

//       {/* Content */}
//       <div className="absolute inset-0 flex flex-col justify-between p-3.5">
//         {/* Date badge — top right */}
//         <div className="flex justify-end">
//           <span className="bg-white/90 text-gray-800 text-xs font-semibold px-2.5 py-1 rounded-lg shadow-sm">
//             {formatDate(dateSource)}
//           </span>
//         </div>

//         {/* Bottom section */}
//         <div className="flex flex-col gap-2">
//           {/* Live bar */}
//           <div className="flex items-center justify-between bg-white/90 backdrop-blur-sm rounded-xl px-3 py-2 shadow-sm">
//             <div className="flex items-center gap-2">
//               <PulseIcon />
//               <span className="text-gray-800 text-sm font-medium">
//                 Live at {formatTime(dateSource)}
//               </span>
//             </div>

//             <button
//               className="w-8 h-8 rounded-full flex items-center justify-center bg-green-600 hover:bg-green-700 transition-colors shadow-sm"
//               aria-label="Play"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 onPress(event);
//               }}
//             >
//               <Play className="w-3.5 h-3.5 text-white fill-white ml-0.5" />
//             </button>
//           </div>

//           {/* Session name */}
//           <span className="text-white text-sm font-semibold drop-shadow pl-0.5 truncate">
//             {event.title}
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─── Main Component ─────────────────────────────────────────────────────── */
// const UpcomingEvents = () => {
//   const { data, isLoading, error } = useUpcomingEvents();
//   const scrollContainerRef = useRef(null);
//   const navigate = useNavigate();

//   const [selectedEvent, setSelectedEvent] = useState(null);

//   const events = data?.streams || data || [];

//   const handleCardPress = (event) => setSelectedEvent(event);
//   const handleCloseModal = () => setSelectedEvent(null);

//   // Navigate to /live/:id with proper event data
//   const handleJoinSession = (event) => {
//     setSelectedEvent(null);

//     const normalised = {
//       ...event,
//       createdAt:
//         event.createdAt ||
//         event.sheduled_at ||
//         event.scheduled_at ||
//         event.date ||
//         new Date().toISOString(),
//       link: event.link || "",
//       // Pass the proper thumbnail for detail page
//       thumbnail: getThumbnailUrl(event),
//       img: event.img || event.thumbnail || null,
//     };

//     navigate(`/live/${event._id}`, { state: { videos: [normalised] } });
//   };

//   // Handle "See All" button click - navigate to live sessions page with all events
//   const handleSeeAll = () => {
//     // Navigate to live page and pass all events data
//     navigate("/live", { 
//       state: { 
//         allEvents: events,
//         source: "upcoming" 
//       } 
//     });
//   };

//   // Not subscribed → /plan
//   const handleSubscribe = () => {
//     setSelectedEvent(null);
//     navigate("/plan");
//   };

//   if (isLoading) {
//     return (
//       <div className="px-5 py-4">
//         <div className="flex items-center justify-between mb-5">
//           <h2 className="text-2xl font-medium text-gray-900">
//             Upcoming Live Sessions
//           </h2>
//         </div>
//         <div className="flex gap-3 overflow-hidden pb-1">
//           {[1, 2, 3].map((i) => (
//             <SkeletonCard key={i} />
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="px-5 py-4">
//         <h2 className="text-2xl font-medium text-gray-900 mb-4">
//           Upcoming Live Sessions
//         </h2>
//         <div className="bg-red-50 border border-red-100 text-red-600 p-4 rounded-xl text-center text-sm">
//           Failed to load upcoming sessions. Please try again later.
//         </div>
//       </div>
//     );
//   }

//   if (!events || events.length === 0) {
//     return (
//       <div className="px-5 py-4">
//         <h2 className="text-2xl font-medium text-gray-900 mb-4">
//           Upcoming Live Sessions
//         </h2>
//         <div className="bg-gray-50 border border-gray-100 text-gray-400 p-8 rounded-xl text-center text-sm">
//           No upcoming sessions scheduled at the moment.
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="px-5 py-4">
//         {/* Header with working See All button */}
//         <div className="flex items-center justify-between mb-5">
//           <h2 className="text-2xl font-medium text-gray-900">
//             Upcoming Live Sessions
//           </h2>
//           <button
//             onClick={handleSeeAll}
//             className="text-green-600 text-sm font-medium hover:text-green-700 transition-colors flex items-center gap-1"
//             aria-label="See all upcoming live sessions"
//           >
//             See All <ChevronRight className="w-4 h-4" />
//           </button>
//         </div>

//         {/* Horizontal scroll - showing limited cards */}
//         <div
//           ref={scrollContainerRef}
//           className="flex gap-3 overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [&::-webkit-scrollbar]:hidden pb-1"
//         >
//           {events.map((event) => (
//             <EventCard key={event._id} event={event} onPress={handleCardPress} />
//           ))}
//         </div>
//       </div>

//       {/* Session Info Modal */}
//       {selectedEvent && (
//         <SessionModal
//           event={selectedEvent}
//           onClose={handleCloseModal}
//           onJoin={handleJoinSession}
//           onSubscribe={handleSubscribe}
//         />
//       )}
//     </>
//   );
// };

// export default UpcomingEvents;

import React, { useRef, useState } from "react";
import { ChevronRight, Play, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useUpcomingEvents } from "../../hooks/useUpcomingEvents";

/* ─── Subscription helper ────────────────────────────────────────────────── */
const hasActiveSubscription = () => {
  try {
    const raw = localStorage.getItem("userSubscription");
    if (!raw) return false;
    const sub = JSON.parse(raw);
    if (sub?.status !== "Active") return false;
    if (!sub?.expiryDate) return false;
    return new Date(sub.expiryDate) > new Date();
  } catch {
    return false;
  }
};



/* ─── Skeleton Card ──────────────────────────────────────────────────────── */
const SkeletonCard = () => (
  <div className="relative min-w-[260px] flex-shrink-0 rounded-2xl overflow-hidden aspect-[3/2] bg-gray-200 animate-pulse" />
);

/* ─── Session Info Modal ─────────────────────────────────────────────────── */
const SessionModal = ({ event, onClose, onJoin, onSubscribe }) => {
  if (!event) return null;

  const isSubscribed = hasActiveSubscription();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-6"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm bg-white rounded-3xl border border-gray-100 shadow-2xl px-6 py-8 flex flex-col items-center gap-5"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <div className="w-full flex justify-end -mt-2">
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>

        {/* Title + status */}
        <div className="flex flex-col items-center gap-2 -mt-2">
          <h3 className="text-gray-900 text-xl font-bold tracking-wide">
            Session Info
          </h3>
          <p className="text-green-600 text-base font-semibold flex items-center gap-2">
            Session Started!
          </p>
        </div>

        {/* Event title */}
        {event.title && (
          <p className="text-gray-500 text-sm text-center leading-relaxed px-2">
            {event.title}
          </p>
        )}

        {/* Divider */}
        <div className="w-full border-t border-gray-100" />

        {/* CTA */}
        {isSubscribed ? (
          <button
            onClick={() => onJoin(event)}
            className="w-full flex items-center justify-between bg-green-600 hover:bg-green-700 active:scale-95 rounded-2xl px-5 py-4 transition-all duration-150 shadow-md"
          >
            <span className="text-white text-base font-bold tracking-wide flex-1 text-center">
              Join Session
            </span>
            <div className="w-7 h-7 bg-white rounded-full flex items-center justify-center">
              <Play className="w-3.5 h-3.5 text-green-600 ml-0.5" fill="currentColor" />
            </div>
          </button>
        ) : (
          <button
            onClick={onSubscribe}
            className="w-full bg-green-600 hover:bg-green-700 active:scale-95 rounded-2xl px-5 py-4 transition-all duration-150 shadow-md"
          >
            <span className="text-white text-base font-bold tracking-wide">
              Subscribe to Watch
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

/* ─── Helper function to get proper thumbnail URL ───────────────────────── */
const getThumbnailUrl = (event) => {
  if (event.img) return event.img;
  if (event.thumbnail) return event.thumbnail;
  if (event.link) {
    const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?#]+)/;
    const match = event.link.match(youtubeRegex);
    if (match && match[1]) {
      return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
    }
  }
  return null;
};

/* ─── Helper function to get MUX playback ID ─────────────────────────────── */
const getPlaybackId = (event) => {
  // Check different possible paths to playback_id
  if (event.muxData?.playback_ids?.[0]?.id) {
    return event.muxData.playback_ids[0].id;
  }
  if (event.muxData?.playbackId) {
    return event.muxData.playbackId;
  }
  if (event.playbackId) {
    return event.playbackId;
  }
  return null;
};

/* ─── Event Card ─────────────────────────────────────────────────────────── */
const EventCard = ({ event, onPress }) => {
  const [imgError, setImgError] = useState(false);
  const thumbnailUrl = getThumbnailUrl(event);
  const playbackId = getPlaybackId(event);
  const isLive = event.muxData?.status === "active";

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = String(date.getFullYear()).slice(2);
    return `${day}-${month}-${year}`;
  };

  const formatTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const dateSource =
    event.sheduled_at || event.scheduled_at || event.date || event.createdAt;

  return (
    <div
      className="relative min-w-[260px] flex-shrink-0 snap-start rounded-2xl overflow-hidden cursor-pointer group aspect-[3/2] border border-gray-100 shadow-md hover:shadow-lg transition-shadow"
      onClick={() => onPress(event)}
    >
      {/* Background image */}
      {thumbnailUrl && !imgError ? (
        <img
          src={thumbnailUrl}
          alt={event.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          onError={() => setImgError(true)}
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-green-50 to-gray-100" />
      )}

      {/* Scrim overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/65" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-between p-3.5">
        {/* Date badge — top right */}
        <div className="flex justify-end">
          <span className="bg-white/90 text-gray-800 text-xs font-semibold px-2.5 py-1 rounded-lg shadow-sm">
            {formatDate(dateSource)}
          </span>
        </div>

        {/* Bottom section */}
        <div className="flex flex-col gap-2">
          {/* Live bar */}
          <div className="flex items-center justify-between bg-white/90 backdrop-blur-sm rounded-xl px-3 py-2 shadow-sm">
            <div className="flex items-center gap-2">
              {isLive }
              <span className="text-gray-800 text-sm font-medium">
                {isLive ? `Live at ${formatTime(dateSource)}` : `Starts at ${formatTime(dateSource)}`}
              </span>
            </div>

            <button
              className="w-8 h-8 rounded-full flex items-center justify-center bg-green-600 hover:bg-green-700 transition-colors shadow-sm"
              aria-label="Play"
              onClick={(e) => {
                e.stopPropagation();
                onPress(event);
              }}
            >
              <Play className="w-3.5 h-3.5 text-white fill-white ml-0.5" />
            </button>
          </div>

          {/* Session name */}
          <span className="text-white text-sm font-semibold drop-shadow pl-0.5 truncate">
            {event.title || "Untitled Session"}
          </span>
        </div>
      </div>
    </div>
  );
};

/* ─── Main Component ─────────────────────────────────────────────────────── */
const UpcomingEvents = () => {
  const { data, isLoading, error } = useUpcomingEvents();
  const scrollContainerRef = useRef(null);
  const navigate = useNavigate();

  const [selectedEvent, setSelectedEvent] = useState(null);

  // FIXED: data is already the streams array from useUpcomingEvents
  const events = data || [];

  const handleCardPress = (event) => setSelectedEvent(event);
  const handleCloseModal = () => setSelectedEvent(null);

  // Navigate to /mux/:id with the full event data
  const handleJoinSession = (event) => {
    setSelectedEvent(null);
    // Pass the entire event object through state
    navigate(`/mux/${event._id}`, {
      state: { eventData: event }
    });
  };



  // Not subscribed → /plan
  const handleSubscribe = () => {
    setSelectedEvent(null);
    navigate("/plan");
  };

  if (isLoading) {
    return (
      <div className="px-5 py-4">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-2xl font-medium text-gray-900">
            Upcoming Live Sessions
          </h2>
        </div>
        <div className="flex gap-3 overflow-hidden pb-1">
          {[1, 2, 3].map((i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-5 py-4">
        <h2 className="text-2xl font-medium text-gray-900 mb-4">
          Upcoming Live Sessions
        </h2>
        <div className="bg-red-50 border border-red-100 text-red-600 p-4 rounded-xl text-center text-sm">
          Failed to load upcoming sessions. Please try again later.
        </div>
      </div>
    );
  }

  if (!events || events.length === 0) {
    return (
      <div className="px-5 py-4">
        <h2 className="text-2xl font-medium text-gray-900 mb-4">
          Upcoming Live Sessions
        </h2>
        <div className="bg-gray-50 border border-gray-100 text-gray-400 p-8 rounded-xl text-center text-sm">
          No upcoming sessions scheduled at the moment.
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="px-5 py-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-2xl font-medium text-gray-900">
            Upcoming Live Sessions
          </h2>
        
        </div>

        {/* Horizontal scroll */}
        <div
          ref={scrollContainerRef}
          className="flex gap-3 overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [&::-webkit-scrollbar]:hidden pb-1"
        >
          {events.map((event) => (
            <EventCard key={event._id} event={event} onPress={handleCardPress} />
          ))}
        </div>
      </div>

      {/* Session Info Modal */}
      {selectedEvent && (
        <SessionModal
          event={selectedEvent}
          onClose={handleCloseModal}
          onJoin={handleJoinSession}
          onSubscribe={handleSubscribe}
        />
      )}
    </>
  );
};

export default UpcomingEvents;